angular.module('picmonicng').component('homeComponent', {
  templateUrl: '/templates/app/pages/home/home.html',
  bindings: {},
  controller: [
    'UserService',
    'User',
    'Picmonics',
    'PlaylistService',
    'Pathways',
    'SpacedRepSettingsModal',
    'SpacedRep',
    'LocalStorageService',
    'toaster',
    'TwentyFourHourDiscountModal',
    'PresentationsService',
    '$cookies',
    'SchoolSourcingModal',
    'GraduationSourcingModal',
    '$modal',
    '$location',
    'MarketOptionsConfig',
    '$state',
    'PQService',
    '$timeout',
    function (
      UserService,
      User,
      Picmonics,
      PlaylistService,
      Pathways,
      SpacedRepSettingsModal,
      SpacedRep,
      LocalStorageService,
      toaster,
      TwentyFourHourDiscountModal,
      PresentationsService,
      $cookies,
      SchoolSourcingModal,
      GraduationSourcingModal,
      $modal,
      $location,
      MarketOptionsConfig,
      $state,
      PQService,
      $timeout
    ) {
      var ctrl = this;
      //test

      ctrl.showProfileMenu = false;
      ctrl.UserService = UserService;
      ctrl.PlaylistService = PlaylistService;
      ctrl.menuItemClicked = false;
      ctrl.showFreeTrialBanner =
        UserService.user.is_trial ||
        (UserService.user.approved_educator === 1 &&
          UserService.user.active_premium_types.includes(3) &&
          UserService.user.active_premium_types.length === 1) ||
        (UserService.user.role === 'Professor' && UserService.user.active_premium_types.length === 0);

      if (typeof PlaylistService.playlists.$promise == 'undefined') {
        PlaylistService.init();
      }
      ctrl.showEduDash =
        UserService.user.approved_educator &&
        !UserService.user.is_trial &&
        UserService.user.school.school_id &&
        UserService.user.school.name.indexOf('Other') === -1;
      try {
        ctrl.showEduDash = ctrl.showEduDash && $cookies.get('dashboard') !== 'student';
      } catch (e) {}

      ctrl.toggleEduDash = function (show) {
        if (show && (!UserService.user.approved_educator || !UserService.user.school.school_id)) {
          var modal = SchoolSourcingModal.show();
          modal.result.finally(function () {
            $state.reload();
          });
          return;
        }

        ctrl.showEduDash = !!show;
        try {
          ctrl.showEduDash ? $cookies.put('dashboard', 'educator') : $cookies.put('dashboard', 'student');
        } catch (e) {}
      };

      ctrl.settings = angular.merge(
        {
          quickStartList: {
            hidden: false,
            tab: UserService.user.is_trial ? 'trial-playlist' : 'recommended',
          },
          stats: {
            hidden: false,
            showMore: true,
          },
          achievements: {
            hidden: false,
          },
          myExperiencePoints: {
            hidden: false,
          },
        },
        LocalStorageService.getItem('home_options')
      );

      function persistData() {
        LocalStorageService.setItem('home_options', ctrl.settings);
      }
      ctrl.$onDestroy = persistData;
      LocalStorageService.onBeforePersist(persistData);

      ctrl.toggleSection = function (section) {
        ctrl.settings[section].hidden = !ctrl.settings[section].hidden;
      };

      //qsl
      ctrl.nextPageRecent = function () {
        if (ctrl.page === -1) {
          return;
        }
        User.recommended({
          type: 'recent',
          page: ++ctrl.recentPage,
        }).$promise.then(function (data) {
          if (ctrl.recentPicmonics.recent) {
            ctrl.recentPicmonics.recent = ctrl.recentPicmonics.recent.concat(data.recent);
          }
          if (!data.recent.length) {
            ctrl.page = -1;
          }
        });
      };

      ctrl.selectTab = function (tab) {
        switch (tab) {
          case 'recommended':
            ctrl.recommendedPicmonics = User.recommended({
              type: 'home',
            });
            break;
          case 'recent':
            ctrl.recentPicmonics = User.recommended({
              type: 'recent',
            });
            ctrl.recentPage = 0;
            ctrl.nextPageRecent();
            break;
          case 'quiz':
            ctrl.queue = User.getv3({
              resource: 'spacedrep',
              resource_id: 'queue',
            });
            break;
          case 'weakest':
            ctrl.weakest = User.weakest({ perPage: 20 });
            break;
          case 'trending':
            ctrl.trendingFilter = { value: 'school' };
            ctrl.trending = Picmonics.query({
              type: 'trending',
              filter: ctrl.trendingFilter.value,
              limit: 20,
            });
            break;
          case 'updated':
            ctrl.updatedPicmonics = Picmonics.get({
              type: 'trending',
              filter: 'updated',
              limit: 50,
            });
            break;
          case 'new':
            ctrl.newPicmonics = Picmonics.get({
              type: 'trending',
              filter: 'new',
              limit: 20,
            });
            break;
          case 'playlists':
            if (typeof PlaylistService.playlists.$promise == 'undefined') {
              PlaylistService.init();
            }
            break;
          case 'bookmarked':
            ctrl.playlists = PlaylistService.getCards({
              playlist_id: 'bookmarked',
            });
            break;
          default:
        }
        ctrl.tab = ctrl.settings.quickStartList.tab = tab;
      };
      ctrl.selectTab(ctrl.settings.quickStartList.tab);

      ctrl.seeMore = function (picmonic) {
        if (ctrl.dqSaving) {
          return;
        }

        ctrl.dqSaving = true;

        User.updatev3(
          {
            resource: 'spacedrep',
            resource_id: 'picmonic',
            resource2: picmonic.card_id,
            picmonic_factor: 0.75,
          },
          function () {
            ctrl.dqSaving = false;
            ctrl.queue = User.getv3({
              resource: 'spacedrep',
              resource_id: 'queue',
            });
            toaster.success(picmonic.name + ' will show up MORE often in your daily quiz.');
          },
          function () {
            toaster.error('Error showing ' + picmonic.name + ' MORE.');
            ctrl.dqSaving = false;
          }
        );
      };

      ctrl.seeLess = function (picmonic) {
        if (ctrl.dqSaving) {
          return;
        }

        ctrl.dqSaving = true;

        User.updatev3(
          {
            resource: 'spacedrep',
            resource_id: 'picmonic',
            resource2: picmonic.card_id,
            picmonic_factor: 1.25,
          },
          function () {
            ctrl.dqSaving = false;
            ctrl.queue = User.getv3({
              resource: 'spacedrep',
              resource_id: 'queue',
            });
            toaster.success(picmonic.name + ' will show up LESS often in your daily quiz.');
          },
          function () {
            toaster.error('Error showing ' + picmonic.name + ' LESS');
            ctrl.dqSaving = false;
          }
        );
      };

      ctrl.remove = function (picmonic) {
        if (ctrl.dqSaving) {
          return;
        }

        if (!confirm('Are you sure you want to completely remove this Topic from your queue?')) {
          return;
        }

        ctrl.dqSaving = true;

        User.deletev3(
          {
            resource: 'spacedrep',
            resource_id: 'picmonic',
            resource2: picmonic.card_id,
          },
          function () {
            ctrl.dqSaving = false;
            ctrl.queue = User.getv3({
              resource: 'spacedrep',
              resource_id: 'queue',
            });
            toaster.success(picmonic.name + ' has been removed from your daily quiz.');
          },
          function () {
            toaster.error('Error removing ' + picmonic.name + ' from your daily quiz.');
            ctrl.dqSaving = false;
          }
        );
      };

      ctrl.atlasEvent = window.atlasEvent;

      var welcomeMessages = [
        'Welcome back, ',
        "Great to see you're back, ",
        'Wonderful to see you again, ',
        "G'day ",
        'Howdy, ',
        'Hiya, ',
        'Hola, ',
      ];

      var encouragmentMessages = [
        "Let's keep up the momentum!",
        'Awesome!',
        "You're amazing!",
        'You rainbow-infused space unicorn of awesomeness, you!',
        'Crushing it!',
        'Wow, rock on!',
        'Nice work!',
        'Excellent!',
        'Well done!',
        'Way to go!',
        'Keep at it!',
        'Outstanding!',
        'Stay strong!',
        'You rock!',
        'Big step forward!',
        'Great progress!',
        "You're on a roll!",
        'Keep it up!',
      ];

      var completionMessages = [
        'You did it!',
        'Nailed it! ',
        'Victorious!',
        'Terrific job!',
        'Splendid!',
        'Nicely done!',
        'Remarkable work!',
        'Superb!',
        'Great job, ',
      ];

      if (UserService.user.cards_viewed === 0 && UserService.user.lead) {
        ctrl.recommendedPicmonics = User.getv3({
          resource: 'first_recommendations',
          market_id: UserService.user.lead,
        });
      } else {
        ctrl.recommendedPicmonics = User.recommended({ type: 'home' });
      }

      ctrl.openSettings = function (tab) {
        var modal = SpacedRepSettingsModal.show(tab);

        modal.result.then(function () {
          ctrl.spacedrep = User.getv3({ resource: 'spacedrepstats' });
          ctrl.spacedrep.$promise.then(function () {
            ctrl.createCtaMessages();
          });
        });
      };

      // Spaced rep stats
      ctrl.createCtaMessages = function () {
        ctrl.cta = 'play';
        if (!ctrl.spacedrep.learned_today && ctrl.spacedrep.next) {
          ctrl.cta = 'quiz';
          ctrl.mainMessage = welcomeMessages[Math.round(Math.random() * 6)] + UserService.user.first_name + '!';
          if (ctrl.spacedrep.current_total + ctrl.spacedrep.current_left) {
            ctrl.subMessage =
              'Start your <strong>' +
              Math.min(ctrl.spacedrep.next, UserService.user.settings.spaced_rep_round_max) +
              '</strong> question Spaced Repetition daily quiz.';
            if (UserService.user.daily_streak) {
              ctrl.minorMessage =
                'Keep your <span class="pls-orange">' + UserService.user.daily_streak + ' day streak</span> alive!';
            }
          } else {
          }
        } else if (ctrl.spacedrep.next) {
          ctrl.cta = 'quiz';
          ctrl.mainMessage = encouragmentMessages[Math.round(Math.random() * 15)];
          ctrl.subMessage =
            'Continue on to your next <span class="pls-blue">' +
            Math.min(ctrl.spacedrep.next, UserService.user.settings.spaced_rep_round_max) +
            ' question' +
            (Math.min(ctrl.spacedrep.next, UserService.user.settings.spaced_rep_round_max) == 1 ? '' : 's') +
            '</span>';
          ctrl.minorMessage = 'You have ' + ctrl.spacedrep.next + ' more questions to complete today.';
        } else if (ctrl.spacedrep.learned_today) {
          const completionMessage = completionMessages[Math.round(Math.random() * 7)];
          if (completionMessage === 'Great job, ') {
            ctrl.mainMessage = completionMessage + UserService.user.first_name + '!';
          } else {
            ctrl.mainMessage = completionMessage;
          }
          ctrl.subMessage = 'You completed your daily quiz.';
          ctrl.recommendedPicmonics.$promise.then(function () {
            ctrl.minorMessage = 'Check out ' + ctrl.recommendedPicmonics.cards[0].display_name + ' next!';
          });
        } else {
          ctrl.mainMessage = welcomeMessages[Math.round(Math.random() * 6)] + UserService.user.first_name + '!';
          ctrl.subMessage = 'Looks like your daily quiz is empty.';
          ctrl.recommendedPicmonics.$promise.then(function () {
            if (ctrl.recommendedPicmonics.cards[0]) {
              ctrl.minorMessage = 'Check out ' + ctrl.recommendedPicmonics.cards[0].display_name + ' next';
            }
          });
        }
      };
      ctrl.spacedrep = User.getv3({
        resource: 'spacedrepstats',
        timezone: moment.tz.guess(),
      });
      ctrl.spacedrep.$promise.then(function () {
        ctrl.createCtaMessages();
      });

      ctrl.newSpacedRep = function () {
        User.savev3({ resource: 'spacedrep' }, function (result) {
          SpacedRep.start(result.next);
        });
      };

      ctrl.checkModals = function () {
        var market = MarketOptionsConfig.getMarketById(UserService.user.lead);
        if (!UserService.user.tos_accepted) {
          UserService.showTOSModal();
        } else if (
          UserService.user &&
          UserService.user.market &&
          !UserService.user.is_trial &&
          !UserService.user.market.is_beta &&
          !UserService.user.school.id &&
          !window.Cypress
        ) {
          UserService.checkIsInNorthAmerica().then(res => {
            if (res) {
              SchoolSourcingModal.show();
            }
          });
        } else if (
          !$cookies.get('pls_graduation_sourcing_modal_seen') &&
          UserService.user &&
          UserService.user.market &&
          !UserService.user.market.is_beta &&
          UserService.user.cards_viewed >= 4 &&
          UserService.user.school &&
          UserService.user.school.id &&
          (!UserService.user.graduation_month || !UserService.user.graduation_year) &&
          UserService.user.role === 'Student'
        ) {
          var expires = new Date();
          expires.setTime(expires.getTime() + 14 * 24 * 60 * 60 * 1000);
          $cookies.put('pls_graduation_sourcing_modal_seen', 1, {
            expires: expires,
          });
          GraduationSourcingModal.show();
        } else if (
          market &&
          !market.is_beta &&
          market.pricing_url !== '/pricing' &&
          UserService.user.user_id &&
          !UserService.seen('twenty_four_hour_discount_modal') &&
          TwentyFourHourDiscountModal.check()
        ) {
          UserService.see('twenty_four_hour_discount_modal');
          TwentyFourHourDiscountModal.showModal();
        } else if ($location.search().srm) {
          srm = $location.search().srm;

          if (srm === 'queue') {
            SpacedRepSettingsModal.show('queue');
          } else if (srm === 'settings') {
            SpacedRepSettingsModal.show('settings');
          }
        }
      };

      ctrl.checkModals();

      ctrl.canSeePracticeQuestions = PQService.canSeePracticeQuestions();
      ctrl.isUserHasInstitutionalSub = Boolean(UserService.user && UserService.user.institutional_sub);

      ctrl.setShowProfileMenu = showProfileMenu => {
        ctrl.showProfileMenu = showProfileMenu;
      };

      ctrl.handleMenuItemClick = () => {
        ctrl.menuItemClicked = true;
      };

      ctrl.handleOnBlurProfileMenu = () => {
        if (!ctrl.menuItemClicked) {
          ctrl.setShowProfileMenu(false);
        }
      };

      ctrl.showStudyScheduler = UserService.user.lead
        ? MarketOptionsConfig.getMarketById(UserService.user.lead).has_pricing
        : false;

      ctrl.showPresoBlock = UserService.user.school.preso_wanted === 1 && UserService.user.school.roadtrip_status < 3;

      ctrl.logout = function () {
        localStorage.clear();
        window.skip_local_storage_persist_on_beforeunload = 1;
        $cookies.remove('picmonic_version');
        window.location.href = '/logout';
      };

      $timeout(() => {
        if ($location.hash()) {
          var element = document.querySelector(`#${$location.hash()}`);
          if (element) {
            window.scrollTo({
              top: element.offsetTop,
              left: 0,
              behavior: 'smooth',
            });
          }
        }
      }, 1500);
    },
  ],
});
